import { passwordCase, passwordNumbers, passwordSpecialChars } from "helpers/password";
import * as v from "valibot";

export const changePasswordRpcContract = {
  name: "changePassword",
  paramsSchema: v.object({
    currentPassword: v.optional(v.string()),
    password: v.pipe(
      v.string(),
      v.minLength(6, "Password must be at least 6 characters"),
      v.maxLength(64, "Password cannot exceed 64 characters"),
      v.regex(passwordSpecialChars, "Password must contain at least one special character"),
      v.regex(passwordNumbers, "Password must contain at least one number"),
      v.regex(passwordCase, "Password must contain both uppercase and lowercase letters"),
    ),
    confirmPassword: v.string(),
    onboarding: v.optional(v.boolean()),
  }),
  resultSchema: v.object({
    message: v.string(),
  }),
};

export type ChangePasswordParams = v.InferOutput<(typeof changePasswordRpcContract)["paramsSchema"]>;
export type ChangePasswordResult = v.InferOutput<(typeof changePasswordRpcContract)["resultSchema"]>;
